import { auth, db } from "../firebase-config";
import { useState, useEffect } from 'react';
import { collection, addDoc, query, where, getDocs, orderBy } from "firebase/firestore"; 
import RateMyClassLogo from '../assets/RateMyClassLogo.png';
import { QuestionIcon} from '@chakra-ui/icons';
import {
  HStack,
  ChakraProvider,
  FormControl,
  FormLabel,
  Button,
  Input,
  Box,
  Select,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  SliderMark,
  Textarea,
  Tooltip,
  Center,
  Radio,
  RadioGroup,
  Stack,
  Link,
  VStack,
  Code,
  Grid,
  theme,
  useToast,
} from '@chakra-ui/react';
import { ColorModeSwitcher } from '../utils/ColorModeSwitcher';
import { Logo } from '../assets/logo.svg';
import { useNavigate } from "react-router-dom";



export default function Review() {
    let navigate = useNavigate();
    const RouteChange = () =>{
        let path = '/submit';    
        navigate(path);
    }
  const invalidToast = useToast();
  // const successToast = useToast();
  const [courseNum, setCourseNum] = useState("");
  const [departmentCode, setDepartmentCode] = useState("");
  const [review, setReview] = useState("");
  const [profName, setProfName] = useState("");
  const [diffRating, setDiffRating] = useState(3);
  const [qualityRating, setQualityRating] = useState(3);
  const [userMajor, setUserMajor] = useState("");
  const [attendance, setAttendance] = useState("");
  const [finalType, setFinalType] = useState("");
  const [grade, setGrade] = useState("");
  
  const labelStyles = {
    mt: '2',
    ml: '-2.5',
    fontSize: 'sm',
  }
  document.body.style.background = 'lightyellow';
  var [sliderColor1, setSliderColor1] = useState("yellow.400");
  var [sliderShade1, setSliderShade1] = useState("yellow.100");
  var [sliderColor2, setSliderColor2] = useState("yellow.400");
  var [sliderShade2, setSliderShade2] = useState("yellow.100");

  

  const setDeptDocID = async (departmentCode) => {
    const q = query(collection(db, "departments"), where("deptCode", "==", departmentCode));
    const querySnapshot = await getDocs(q);
    var departmentDocID = "";
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      departmentDocID = doc.id;
    });
    return departmentDocID;
  }

  return (
    <ChakraProvider theme={theme}>
      <Center>
      <Box textAlign="center" fontSize="xl" maxW="xl">
        <div class="center-image">
          <img src={RateMyClassLogo} alt = "Rectangular logo" />
        </div>
        
        
        

        <HStack>
        <FormControl id="departmentCode" isRequired>
        <FormLabel > Department Code </FormLabel>
                <Input value={departmentCode} placeholder = "CS"  _placeholder={{ opacity: 0.75, color: 'grey.400' }} onChange={(e) => setDepartmentCode(e.target.value) } />
                  
        </FormControl>
              {/* add course code input here */}
        <FormControl id="courseNum" isRequired>
            <FormLabel>Course Num </FormLabel>
                <Input value={courseNum} placeholder = "4291"  _placeholder={{ opacity: 0.75, color: 'grey.400' }} onChange={(e) => setCourseNum(e.target.value) } />
            
        </FormControl>
        </HStack>
        <FormControl id="profName" isRequired>
              <FormLabel>Professor Name</FormLabel>
              <Input value={profName} placeholder = "Last Name Only" onChange={(e) => setProfName(e.target.value) } />
            </FormControl>
          <FormControl id="diff" isRequired>
            <FormLabel>Course Difficulty Rating</FormLabel>
            <Slider defaultValue={3} min={1} max={5} step={1} 
            onChange=
            {(val) => {
              setDiffRating(val);
              if (val === 1) {setSliderColor1("green.400"); setSliderShade1("green.100")}
              if (val === 2) {setSliderColor1("green.400"); setSliderShade1("green.100")} 
              if (val === 3) {setSliderColor1("yellow.400"); setSliderShade1("yellow.100")} 
              if (val === 4) {setSliderColor1("orange.400"); setSliderShade1("orange.100")}
              if (val === 5) {setSliderColor1("red.400"); setSliderShade1("red.100")}  
            }
            } 
            onChangeEnd={
              (val) => setDiffRating(val)}>
              <SliderMark value={1} {...labelStyles}>
                1
              </SliderMark>
              <SliderMark value={2} {...labelStyles}>
                2
              </SliderMark>
              <SliderMark value={3} {...labelStyles}>
                3
              </SliderMark>
              <SliderMark value={4} {...labelStyles}>
                4
              </SliderMark>
              <SliderMark value={5} {...labelStyles}>
                5
              </SliderMark>
              <SliderTrack bg={sliderShade1}>
                <Box position='relative' right={10} />
                <SliderFilledTrack bg={sliderColor1} />
              </SliderTrack>
              <SliderThumb boxSize={4} />
            </Slider>
          </FormControl>
          <Box h={5}/>
          <FormControl id="quality" isRequired>
              <FormLabel>Course Quality Rating</FormLabel>
              <Slider defaultValue={3} min={1} max={5} step={1} 
              onChange=
              {(val) => {
                setQualityRating(val);
                if (val === 1) {setSliderColor2("red.400"); setSliderShade2("red.100")}
                if (val === 2) {setSliderColor2("orange.400"); setSliderShade2("orange.100")} 
                if (val === 3) {setSliderColor2("yellow.400"); setSliderShade2("yellow.100")} 
                if (val === 4) {setSliderColor2("green.200"); setSliderShade2("green.50")}
                if (val === 5) {setSliderColor2("green.400"); setSliderShade2("green.100")}  
              }
             }>
                <SliderMark value={1} {...labelStyles}>
                  1
                </SliderMark>
                <SliderMark value={2} {...labelStyles}>
                  2
                </SliderMark>
                <SliderMark value={3} {...labelStyles}>
                  3
                </SliderMark>
                <SliderMark value={4} {...labelStyles}>
                  4
                </SliderMark>
                <SliderMark value={5} {...labelStyles}>
                  5
                </SliderMark>
                <SliderTrack bg={sliderShade2}>
                  <Box position='relative' right={10} />
                  <SliderFilledTrack bg={sliderColor2} />
                </SliderTrack>
                <SliderThumb boxSize={4} />
              </Slider>
            </FormControl>
            <Box h={5}/>
            <FormControl id="attendance" isRequired>
              <FormLabel>Mandatory Attendance?</FormLabel>
              <RadioGroup onChange={(val) => setAttendance(val)} value={attendance}>
                <Stack direction='row'>
                  <Radio value='1'>Yes</Radio>
                  <Radio value='2'>No</Radio>
                  <Radio value='3'>Sometimes</Radio>
                </Stack>
              </RadioGroup>
            </FormControl>
            <FormControl id="finalType" isRequired>
              <FormLabel>Final Type?</FormLabel>
              <RadioGroup onChange={(val) => setFinalType(val)} value={finalType}>
                <Stack direction='row'>
                  <Radio value='1'>Exam</Radio>
                  <Radio value='2'>Project</Radio>
                  <Radio value='3'>Paper</Radio>
                  <Radio value='4'>Presentation</Radio>
                  <Radio value='5'>None</Radio>
                  <Radio value='6'>Other</Radio>
                </Stack>
              </RadioGroup>
            </FormControl>
            <FormControl id="grade" isRequired>
              <FormLabel>Grade Earned</FormLabel>
                <Select onChange={(val) => setGrade(val.target.value)} value={grade}>
                  <option hidden value="">Select Option</option>
                  <option value='1'>No Grade Received Yet</option>
                  <option value='2'>A</option>
                  <option value='3'>A-</option>
                  <option value='4'>B+</option>
                  <option value='5'>B</option>
                  <option value='6'>B-</option>
                  <option value='7'>C+</option>
                  <option value='8'>C</option>
                  <option value='9'>C-</option>
                  <option value='10'>D+</option>
                  <option value='11'>D</option>
                  <option value='12'>D-</option>
                  <option value='13'>F</option>
                  <option value='14'>W (Withdrew)</option>
                  <option value='15'>I (Incomplete)</option>
                </Select>
            </FormControl>
          <FormControl id="review" isRequired>
            <FormLabel>Review</FormLabel>
            <Textarea
              value={review}
              onChange={(e) => setReview(e.target.value) }
              placeholder='Enter your review here'
              size='md'
            />
          </FormControl>
          <FormControl id="major" isRequired>
            <FormLabel>Your Major
            </FormLabel>
            <Input value={userMajor} placeholder = "Computer Science" onChange={(e) => setUserMajor(e.target.value) } />
          </FormControl>
          <Box h={5}/>
        <Button 
          colorScheme="blue" 
          onClick={async () => {
          if (profName === "" || departmentCode === "" || courseNum === "" 
          || review === "" || attendance === "" || grade === "" || finalType === "" 
          || userMajor === "" || (courseNum.length > 5 || courseNum.length < 4)) {
            invalidToast({
              position: "bottom-right",
              title: 'Submission failed.',
              status: 'error',
              description: "Fill in all fields properly before submitting your review!",
              duration: 9000,
              isClosable: true,
            })
          } 

          else if (departmentCode === "EECE" ){
            invalidToast({
              position: "bottom-right",
              title: 'EECE is now named ECE.',
              status: 'error',
              description: "Please fix department code",
              duration: 9000,
              isClosable: true,
            })
            
              
          }
          else {
            try {
              var deptDocID = await setDeptDocID(departmentCode);
              const timestamp = new Date().toISOString();
              console.log(qualityRating);
              console.log(diffRating);
              addDoc(collection(db, `departments/${deptDocID}/courses`), {profName: profName, courseNum: courseNum, review: review, 
                diffRating: diffRating, qualityRating: qualityRating, attendance: attendance, grade: grade,
                finalType: finalType, userMajor: userMajor, departmentCode: departmentCode, timestamp: timestamp});
                RouteChange();
              
            } catch (e) {
              console.log(e);
              invalidToast({
                position: "bottom-right",
                title: 'Department code not valid.',
                status: 'error',
                description: "Correct your department code before submitting!",
                duration: 9000,
                isClosable: true,
              })
            }
            
              
          }
            
        }
           
        }>Submit Review</Button>
        <Box h={10}/>
      </Box>
      </Center>
    </ChakraProvider>
  );

}
//we need to figure out where to put this. we need to do a style sheet
/*.center-image{
  height:300px;
  width:300px;
  background:orange;
  position:relative;
 }

.center-image img{
  max-width:100%;
  max-height:100%;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
}*/
